// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listSubSectionCss_lzhgygs{list-style:none;padding:20px 0 0;margin:0;}.listSubSectionCss_lzhgygs:focus{outline:none;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-ui/dist/es/list/ListSubSection.css"],"names":[],"mappings":"AAAA,2BAA2B,eAAe,CAAC,gBAAgB,CAAC,QAAQ,CAAC,CAAC,iCAAiC,YAAY,CAAC","sourcesContent":[".listSubSectionCss_lzhgygs{list-style:none;padding:20px 0 0;margin:0;}.listSubSectionCss_lzhgygs:focus{outline:none;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
